import * as React from 'react';
import { useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import CardContent from '@mui/material/CardContent';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import { JsonFormsCore } from '@jsonforms/core';

import { Form } from './forms/form';

const FormWrapper = styled('div')(() => ({
  margin: 'auto',
  padding: '1rem',
  overflow: 'inherit',
}));

const StyledHeader = styled(CardHeader)(({ theme }) => ({
  borderBottomColor: theme.palette.divider,
  borderBottomWidth: 1,
  borderBottomStyle: 'solid',
  padding: 8,
  color: '#000000',
}));

const StyledContent = styled(CardContent)(() => ({
  '& .MuiPaper-elevation1': {
    boxShadow: '0 0 0 0',
  },
  // '& .MuiInputLabel-formControl': {
  //   top: '2px',
  //   left: '5px',
  // },
}));

interface ReadonlyFormProps {
  onChange?(state: Pick<JsonFormsCore, 'data' | 'errors'>): void;
  data: any;
  title: string;
  uischema: any;
  schema: any;
}

export const ReadonlyFormCard = ({
  title,
  data,
  schema,
  uischema,
  onChange,
}: ReadonlyFormProps) => {
  const [props, setProps] = useState<any>(data);

  useEffect(() => {
    setProps(data);
  }, [data]);

  // On change handler
  const _changeHandler = (state: Pick<JsonFormsCore, 'data' | 'errors'>) => {
    if (state.data) {
      setProps(state.data);
    }
    if (onChange) {
      onChange(state);
    }
  };

  return (
    <FormWrapper>
      <Card>
        <StyledHeader title={title} disableTypography />
        <StyledContent>
          <Form
            onChange={_changeHandler}
            data={props}
            uischema={uischema}
            schema={schema}
            isReadonly
          />
        </StyledContent>
      </Card>
    </FormWrapper>
  );
};
